module.exports = __webpack_public_path__ + "static/media/mainLogo.605db45f.png";